import { useState } from 'react';
import { KioskRecipeDetail } from './KioskRecipeDetail.jsx';
import { KioskRecipeList } from './KioskRecipeList.jsx';
import { KioskDocDetail } from './KioskDocDetail.jsx';
import { KioskDocList } from './KioskDocList.jsx';
import { KioskScheduleWeek } from './KioskScheduleWeek.jsx';

export function KioskKnowledgeView({ session }) {
  // Sub-tabs: Recipes, Policies, Schedule. Equipment + Maintenance
  // were promoted to top-level kiosk tabs (they were buried here).
  const [tab, setTab] = useState('recipes');
  const [open, setOpen] = useState(null);
  const tabs = [
    ['recipes',  '🍵 Recipes'],
    ['policies', '📋 Policies & SOPs'],
    ['schedule', '📅 Schedule'],
  ];
  return (
    <div>
      <div style={{ display: 'flex', gap: 4, borderBottom: '1px solid #e0e0e0', marginBottom: 12, overflowX: 'auto' }}>
        {tabs.map(([id, label]) => (
          <button key={id} onClick={() => { setTab(id); setOpen(null); }}
            style={{ padding: '10px 16px', fontSize: 13, fontWeight: 600,
                      background: 'transparent', border: 'none',
                      borderBottom: `2px solid ${tab === id ? 'var(--forest)' : 'transparent'}`,
                      color: tab === id ? '#212121' : '#757575',
                      cursor: 'pointer', fontFamily: 'inherit', whiteSpace: 'nowrap' }}>
            {label}
          </button>
        ))}
      </div>
      {tab === 'recipes' && (open
        ? <KioskRecipeDetail session={session} id={open.id} onBack={() => setOpen(null)} />
        : <KioskRecipeList session={session} onOpen={id => setOpen({ kind: 'recipe', id })} />)}
      {tab === 'policies' && (open
        ? <KioskDocDetail session={session} id={open.id} onBack={() => setOpen(null)} />
        : <KioskDocList session={session} onOpen={id => setOpen({ kind: 'doc', id })} />)}
      {tab === 'schedule' && <KioskScheduleWeek session={session} />}
    </div>
  );
}
